import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { UpsertGoalModal } from "modules/campaigns/components/Sections/goals/UpsertGoalModal"
import { GoalsListSearchSchema } from "./route"

export const Route = createFileRoute("/_base/_auth/campaigns/goals/list/edit/$id")({
  component: RouteComponent,
  validateSearch: (search) => {
    return GoalsListSearchSchema.parse(search)
  },
})

function RouteComponent() {
  const { id } = Route.useParams()
  const search = Route.useSearch()
  const navigate = useNavigate()

  function onClose() {
    navigate({ to: "/campaigns/goals/list", search })
  }

  return <UpsertGoalModal id={id} onClose={onClose} />
}
